export default __webpack_public_path__ + "static/media/Meta.79721eb9.svg";